function exportCSV(data = [], columns = [], fileName = 'export.csv') {
  if (!fileName) {
    return;
  }
  let csvText = '';
  const attributes = {};
  columns.forEach((column, index) => {
    const prefix = index !== 0 ? ',' : '';
    const suffix = index === columns.length - 1 ? '\n' : '';
    if (column.attribute) {
      const attr = column.attribute;
      attributes[column.id] = attr;
      csvText += `${prefix}${attr.displayName}${suffix}`;
    } else {
      csvText += `${prefix}${column.Header}${suffix}`;
    }
  });
  data.forEach(row => {
    columns.forEach((column, index) => {
      const prefix = index !== 0 ? ',' : '';
      const suffix = index === columns.length - 1 ? '\n' : '';
      const attr = attributes[column.id];
      if (attr) {
        let value = attr.get(row.data);
        value = value?.value ? `${value.value} ${value.unit}` : value;
        const formatted = value != null ? value : '--';
        csvText += `${prefix}${formatted}${suffix}`;
      } else {
        if (typeof column.accessor === 'function') {
          csvText += `${prefix}${column.accessor(row)}${suffix}`;
        }
        if (typeof column.accessor === 'string') {
          csvText += `${prefix}${row[column.accessor]}${suffix}`;
        }
      }
    });
  });
  exportFile(csvText, fileName);
}
async function exportFile(csv, fileName) {
  const blob = new Blob([csv], {
    type: 'text/plain'
  });
  const url = URL.createObjectURL(blob);
  saveAs(url, fileName);
}
function saveAs(uri, fileName) {
  const link = document.createElement('a');
  if (typeof link.download === 'string') {
    document.body.appendChild(link); // Firefox requires the link to be in the body
    link.download = fileName;
    link.href = uri;
    link.click();
    document.body.removeChild(link); // remove the link when done
  } else {
    location.replace(uri); // eslint-disable-line no-restricted-globals
  }
}
export default {
  exportFile,
  exportCSV
};